import React from 'react';
import { SpendTableColumn } from './VirtualizedSpendTable';

interface LockedInputRowProps<T> {
  inputRow: T;
  columns: SpendTableColumn<T>[];
  renderCell: (row: T, columnKey: string, rowIdx: number, colIdx: number) => React.ReactNode;
}

// Shared component for locked input row - ensures perfect alignment with header and data rows
export function LockedInputRow<T>({ inputRow, columns, renderCell }: LockedInputRowProps<T>) {
  return (
    <div className="virtualized-table overflow-x-hidden">
      <table className="w-full theme-text-light table-fixed" style={{ tableLayout: 'fixed' }}>
        <colgroup>
          {columns.map((column) => (
            <col key={column.key} style={{ width: column.width || 'auto' }} />
          ))}
        </colgroup>
        <tbody>
          <tr className="table-row input-row bg-[var(--bg-elev)]">
            {columns.map((column, colIdx) => {
              const alignClass = column.align === 'left' ? 'text-left' : column.align === 'right' ? 'text-right' : 'text-center';
              return (
                <td 
                  key={column.key} 
                  className={`theme-text-light ${alignClass} ${column.key === 'actions' ? 'actions-cell' : ''}`}
                  style={{ width: column.width || 'auto', paddingTop: '22px', paddingBottom: '22px', paddingLeft: '24px', paddingRight: '24px' }}
                >
                  {renderCell(inputRow, column.key, -1, colIdx)}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

